import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { generateEntity } from 'src/shared/entities/utils/generate-base-entity'
import { MasterBlockIdType } from 'src/shared/schemas/master-block-id.schema'
import { WebsiteSettingsTypographyTypeEnum } from 'src/shared/types/website-settings-types'
import { LoginButtonEntityInterface } from './login-button-entity.schema'

export const createLoginButton = (
  parentId: string,
  text: string,
  subText: string,
  masterBlockId?: MasterBlockIdType,
): LoginButtonEntityInterface => {
  return {
    ...generateEntity(EntityTypeEnum.LoginButton, parentId, masterBlockId),
    buttonType: WebsiteSettingsTypographyTypeEnum.SecondaryButton,
    iconClassNameBefore: '',
    iconClassNameAfter: '',
    alignSelf: 'center',
    text,
    subText,
    width: 'auto',
    boxShadow: 'none',
    mobileWidth: '100%',
    mobileAlignSelf: 'center',
    mobileBoxShadow: 'none',
  }
}
